// extracted by mini-css-extract-plugin
export var wrapper = "SecondQuestion-module--wrapper----rrN";
export var headline = "SecondQuestion-module--headline--6-200";
export var questionBlok = "SecondQuestion-module--questionBlok--M7xBU";
export var question = "SecondQuestion-module--question--3aSm1";
export var inputText = "SecondQuestion-module--inputText--FeRxP";
export var checkboxIcon = "SecondQuestion-module--checkboxIcon--LCLK7";
export var checkboxCheckIcon = "SecondQuestion-module--checkboxCheckIcon--2te9r";